import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "../components/App";
import "../styles/application.css"

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
